module.exports = __webpack_public_path__ + "media/src/images/icon/fa-tw-5b0a5a1e64af28d50205e9342156cac4.png";